module.exports = __webpack_public_path__ + "static/media/eye.1557fe89.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/eye.svg
// module id = 287
// module chunks = 7